import React from "react";

export type Breakpoint = "mobile" | "desktop";

const useBreakpoint = (): Breakpoint => {
    const [breakpoint, setBreakpoint] = React.useState<Breakpoint>("desktop");
    React.useEffect(() => {
        const update = () => {
            if (window.innerWidth < 600) setBreakpoint("mobile");
            else setBreakpoint("desktop");
        };
        window.addEventListener("resize", update);
        update();
        return () => window.removeEventListener("resize", update);
    }, []);
    return breakpoint;
};

export default useBreakpoint;